import { JackpotPotSVG } from '@media/svgs'
import { REWARD_TYPE } from '@constants/tournamentConstants'

// Pure render — one "others" table row (ranks 4+, or the viewer bumped to the
// front — see leaderboardView.js). `columns` is the same config the header
// row renders from (built once per tab, not per row).
const LeaderboardRow = ({ row, columns, currencyCode }) => (
  <div
    className={`standard-normal-leaderboard-table-row ${row.isMe ? 'standard-normal-leaderboard-table-row-me' : ''}`}
  >
    {columns.map((col) => (
      <div key={col.key} className="standard-normal-leaderboard-table-row-col">
        <span>{row[col.key] ?? '--'}</span>
        {col.isReward && row.rewardType === REWARD_TYPE.FREEBET && <JackpotPotSVG width="10" height="10" />}
        {col.isReward && row.rewardType === REWARD_TYPE.AMOUNT && (
          <span className="standard-normal-leaderboard-table-row-col-currency">{currencyCode}</span>
        )}
      </div>
    ))}
  </div>
)

export default LeaderboardRow
